import React, { useCallback, useState } from 'react'

import { Input } from '@centivo/react-components'

import { useMediaContext } from 'src/context/responsive'
import { useGlobalState } from 'src/context/global'

import classNames from 'classnames'
import { Content } from 'src/refactor/structure'
import { StyledEligibility } from './components'

const EligibilityExplanation: React.FC<{
  isEligible: boolean | null
  isMobileView?: boolean
}> = ({ isEligible, isMobileView }) => {
  const [{ appConfig }] = useGlobalState()
  const { shouldShowEligibilityLink } = appConfig

  if (isEligible === null) {
    return shouldShowEligibilityLink ? <p>&nbsp;</p> : null
  }
  return isEligible ? (
    <p>
      <b>Yes</b>, you are eligible for the Partnership Option!
      {!shouldShowEligibilityLink && (
        <>
          <br />
          Please continue on{' '}
          <a
            target="_blank"
            href="https://flimp.live/2023_Jetblue_PSnav"
            rel="noreferrer"
          >
            PLANselect
          </a>{' '}
          to learn more.
        </>
      )}
    </p>
  ) : (
    <p>
      <b>Unfortunately</b>, you don’t live in an area eligible for the
      Partnership Option. {!isMobileView && <br />}
      {!shouldShowEligibilityLink && (
        <>
          Please continue on{' '}
          <a
            target="_blank"
            href="https://flimp.live/2023_Jetblue_PSnav"
            rel="noreferrer"
          >
            PLANselect
          </a>{' '}
          to learn more about your options.
        </>
      )}
    </p>
  )
}

export const Eligibility: React.FC = () => {
  const { isMobileView } = useMediaContext()
  const [{ appConfig }] = useGlobalState()
  const { eligibilityZipCodes, shouldShowEligibilityLink } = appConfig
  const [isEligible, setIsEligible] = useState<boolean | null>(null)

  const [zipCode, setZipCode] = useState('')

  const onZipCodeChange = useCallback(
    (newZip: string) => {
      if (isEligible !== null) setIsEligible(null)
      setZipCode(newZip)
    },
    [isEligible, setZipCode, setIsEligible]
  )

  const onSearchZip = useCallback(() => {
    setIsEligible(eligibilityZipCodes?.includes(zipCode) ?? null)
  }, [setIsEligible, zipCode, eligibilityZipCodes])

  return (
    <Content>
      <StyledEligibility>
        <h1>Are you eligible for the Partnership Option?</h1>
        <h3>
          If you’re a JetBlue Crewmember living in the <b>Northeast</b>,{' '}
          <b> Central Florida</b> or <b>Southern California</b>, you may have
          access to an affordable, easy-to-use Medical Option.*
        </h3>

        <div
          className={classNames('eligibility-form-content', {
            'with-link': shouldShowEligibilityLink,
          })}
        >
          <h6>
            Enter in your home address ZIP code to see if you’re eligible.
          </h6>
          <Input
            name="zipCode"
            id="zipCode"
            className="zip-search"
            label="ZIP code"
            placeholder="ZIP code (required)"
            maxLength={5}
            inputMode="numeric"
            clearIcon="slice-x-circle"
            float
            iconGroup={[
              {
                key: 'map-pin-icon',
                icon: 'slice-location',
                placement: 'left',
                color: '#44190a',
              },
              {
                key: 'search-icon',
                icon: 'slice-search',
                placement: 'right',
                onClick: onSearchZip,
                color: '#44190a',
              },
            ]}
            onPressEnter={onSearchZip}
            onChangeValue={onZipCodeChange}
            isClearable
          />
          <EligibilityExplanation
            isEligible={isEligible}
            isMobileView={isMobileView}
          />
        </div>
      </StyledEligibility>
    </Content>
  )
}
